var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("nav", { staticClass: "breadcrumb is-small has-dot-separator" }, [
        _c("ul", [
          _c(
            "li",
            [_c("b-icon", { attrs: { icon: "home", size: "is-small" } })],
            1
          ),
          _c("li", { staticClass: "is-active" }, [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(_vm._s(_vm.$t("pro-doc.message1")))
            ])
          ]),
          _c("li", { staticClass: "is-active" }, [
            _c("a", { attrs: { href: "#" } }, [
              _vm._v(_vm._s(_vm.$t("pro-doc.message2")))
            ])
          ])
        ])
      ]),
      _c("h1", { staticClass: "is-size-4" }, [
        _vm._v(_vm._s(_vm.$t("pro-doc.message2")))
      ]),
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "b-field",
                [
                  _c("b-input", {
                    attrs: {
                      placeholder: _vm.$t("pro-doc.message5"),
                      type: "search",
                      icon: "search",
                      size: "is-small"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.filters, function(filter) {
            return _c(
              "div",
              { key: "filter" + filter.label, staticClass: "filter" },
              [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(filter.label) + " :")
                ]),
                _c(
                  "b-dropdown",
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-full-width is-small is-light",
                        attrs: { slot: "trigger" },
                        slot: "trigger"
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("pro-doc.message3")))
                        ]),
                        _c("b-icon", {
                          attrs: { icon: "chevron-down", size: "is-small" }
                        })
                      ],
                      1
                    ),
                    _c("b-dropdown-item", [
                      _vm._v(_vm._s(_vm.$t("pro-doc.message4")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          }),
          _c("div", { staticStyle: { clear: "both" } })
        ],
        2
      ),
      _c("b-table", {
        attrs: {
          data: _vm.items,
          "default-sort": ["title", "asc"],
          "mobile-cards": false
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(props) {
              return [
                _c(
                  "b-table-column",
                  [
                    _c("b-icon", {
                      attrs: { icon: "file", size: "is-small", pack: "far" }
                    })
                  ],
                  1
                ),
                _c(
                  "b-table-column",
                  { attrs: { field: "title", label: "Nom", sortable: "" } },
                  [_vm._v(_vm._s(props.row.title))]
                ),
                _c(
                  "b-table-column",
                  { attrs: { field: "nature", label: "Nature", sortable: "" } },
                  [_vm._v(_vm._s(props.row.nature))]
                ),
                _c(
                  "b-table-column",
                  {
                    attrs: {
                      field: "immeuble",
                      label: "Immeuble",
                      sortable: ""
                    }
                  },
                  [_vm._v(_vm._s(props.row.immeuble))]
                ),
                _c(
                  "b-table-column",
                  {
                    attrs: {
                      field: "enseigne",
                      label: "Enseigne",
                      sortable: ""
                    }
                  },
                  [_vm._v(_vm._s(props.row.enseigne))]
                ),
                _c(
                  "b-table-column",
                  { attrs: { field: "bail", label: "Bail", sortable: "" } },
                  [_vm._v(_vm._s(props.row.bail))]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }